// extracted by mini-css-extract-plugin
module.exports = {"spacer":"Footer_spacer__1lE6T"};